import React, { useRef, useState, useEffect } from "react";
import { Input } from "antd";
import { usePlacesWidget } from "react-google-autocomplete";
import { IoLocationOutline } from "react-icons/io5";
import { MAP_API_KEY } from "../config/config";

const PlaceAutocomplete = (props) => {
  // -------------------------- VAR --------------------------
  const { options, disabled, value, icon, name } = props;
  const { ref: antRef } = usePlacesWidget({
    apiKey: MAP_API_KEY,
    options,
    onPlaceSelected: (place) => {
      const newAddress = place?.formatted_address || "";
      setAddress(newAddress);
      // console.log("place", place);
      props.onSelect(place);
    },
  });
  // -------------------------- STATE --------------------------
  const [address, setAddress] = useState("");
  const inputRef = useRef(null);
  // -------------------------- REDUX --------------------------

  // -------------------------- FUNCTION --------------------------

  const onChange = (e) => {
    const newAddress = e.target.value;
    setAddress(newAddress);
  };

  // -------------------------- EFFECT --------------------------
  useEffect(() => {
    setAddress(value);
  }, [value]);

  // -------------------------- RENDER --------------------------

  // -------------------------- MAIN --------------------------

  return (
    <Input.Search
      ref={(c) => {
        inputRef.current = c;
        if (c) antRef.current = c.input;
      }}
      name={name ? name : "address"}
      value={address}
      type="text"
      disabled={disabled}
      onChange={onChange}
      style={{ width: "100%" }}
      prefix={icon ? icon : <IoLocationOutline />}
    />
  );
};

export default PlaceAutocomplete;
